import axios from "axios";
import configuration from "./config.json";
import Cookies from "universal-cookie";

const cookies = new Cookies();

var base_url = configuration.URL_BASE.development;


var entityId = cookies.get("ente") ? cookies.get("ente").idEnte : "";

var operator =
  cookies.get("user_profile") && cookies.get("user_profile").WorkingRole;

var clientId = "bari_test";
// var entityId = "8fefaafb-5a9f-44a6-b499-e4b56998eaf4";

const Repo = {


    getConfigValue: () => {

        var axios = require('axios');

        var config = {
            method: 'get',
            url: '/data.json',
            headers: {}
        };

        return axios(config)
            

    },

    getUserProfile: (token) =>
    axios({
      method: "GET",
      url:
        base_url +
        configuration.URL_GET_PROFILE +
        "clientId=" +
        clientId +
        "&entityId=" +
        entityId,
      headers: {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "example.com",
        Authorization: "Bearer " + token,
      },
      params: {},
    }),

    

};

export default Repo;
